import React, { useState, useEffect, useRef } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import uuid from 'react-uuid';
import { Formik } from 'formik';
import ExperienceForm from './ExperienceForm';
import WarningNotiifcation from 'components/WarningNotification';
import { SetLoading } from "redux/actions/loadingActions";
import { connect } from 'react-redux';
import { updateMany } from 'services';
import { SetUser } from "redux/actions/userActions";
import { SetOperationSuccess  } from "redux/actions/operationSuccessActions";
import { SetHasExperience } from "redux/actions/hasExperienceDataActions";
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from "react-router";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let yup = require('yup');

const ExperienceFormWrapper = ({data, user, SetLoading, SetOperationSuccess, opeationSuccess, SetHasExperience, hasExperienceDataReducer}) => {
    const [experienceForm, setExperienceForm] = useState([]);
    const [exampleOptionsArray, setExampleOptionsArray] = useState([]);
    const [loadForm, setLoadForm] = useState(false);
    const [formContent, setFormContent] = useState({});
    const [formikSchema, setFormikSchema] = useState({});
    const [basicSchema, setBasicSchema] = useState({});
    const formRef = useRef();
    const [saveAndContinue, setSaveAndContinue] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        setExampleOptionsArray(() => {
            return [{ value: '', label: 'Seleccione...' }, { value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]
        });

        if (data && data.length > 0) {
            let schema = {};
            let values = {};
            let list = [];
            user.persona.personaExperiencia = data;

            data.forEach(element => {
                const elementId = element.id;

                schema = {
                    ...schema,
                    [`company_${elementId}`]: yup.string().required("El campo es requerido"),
                    [`startDate_${elementId}`]: yup.string().notRequired(),
                    [`endDate_${elementId}`]: yup.string().notRequired(),
                    //[`stall_${elementId}`]: yup.string().required("El campo es requerido"),
                    [`monthlySalary_${elementId}`]: yup.string().required("El campo es requerido"),
                    [`startyear_${elementId}`]: yup.number('Deben ser sólo números').test('len', 'Debes agregar solo 4 números!', val => !val || (val && val.toString().length === 4)).notRequired(), 
                    [`endyear_${elementId}`]: yup.number('Deben ser sólo números').test('len', 'Debes agregar solo 4 números!', val => !val || (val && val.toString().length === 4)).notRequired(),
                    [`supervisor_${elementId}`]: yup.string().required("El campo es requerido"),
                    [`functions_${elementId}`]: yup.string().required("El campo es requerido"),
                    [`departureReason_${elementId}`]: yup.string().notRequired(),
                    [`phone_${elementId}`]: yup.string().required("El campo es requerido"),
                    [`current_${elementId}`]: yup.bool()
                };

                values = {
                    ...values,
                    [`company_${elementId}`]: element.empresaNombre ?? '',
                    [`startDate_${elementId}`]: element.mesInicioId ?? '',
                    [`endDate_${elementId}`]: element.mesFinId ?? '',
                    //[`stall_${elementId}`]: element.estudioAreaId,
                    [`monthlySalary_${elementId}`]: element.salario,
                    [`startyear_${elementId}`]: element.anioInicio ? element.anioInicio : '',
                    [`endyear_${elementId}`]: element.anioFin ? element.anioFin : '',
                    [`supervisor_${elementId}`]: element.supervisor,
                    [`functions_${elementId}`]: element.ocupacion,
                    [`departureReason_${elementId}`]: element.motivoSalida ? element.motivoSalida : '',
                    [`phone_${elementId}`]: element.empresaTelefono,
                    [`current_${elementId}`]:  (element.actual === 0? false : true),
                   };

                list.push({
                 id: elementId,
                 estado: element.estado,
                 isNew: false,
                })
            });

            updateFormik(schema);

            setFormContent(() => {
                return values
            });

            setExperienceForm(() => {
                return [
                    ...list
                ];
            });
        }

        setLoadForm(true);
    }, [])

    useEffect(() => {
        if (loadForm) {
            if (data && data.length == 0) {
                onAddExperienceForm();
            }
        }
    }, [loadForm]) 

    const notify = (text) => toast.warn(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });


    const updateFormik = (schema) => setFormikSchema(() => {
        return yup.object(schema);
    });

    const onAddExperienceForm = () => {
        const guid = uuid();
        const oldValues = formRef.current.values;

        const newSchema = {
            ...basicSchema,
            [`company_${guid}`]: yup.string().required("El campo es requerido"),
            [`startDate_${guid}`]: yup.string().notRequired(),
            [`endDate_${guid}`]: yup.string().notRequired(),
            //[`stall_${guid}`]: yup.string().required("El campo es requerido"),
            [`monthlySalary_${guid}`]: yup.string().required("El campo es requerido"),
            [`startyear_${guid}`]: yup.number('Deben ser sólo números').test('len', 'Debes agregar solo 4 números!', val => !val || (val && val.toString().length === 4)).notRequired(),
            [`endyear_${guid}`]: yup.number('Deben ser sólo números').test('len', 'Debes agregar solo 4 números!', val => !val || (val && val.toString().length === 4)).notRequired(),
            [`supervisor_${guid}`]: yup.string().required("El campo es requerido"),
            [`functions_${guid}`]: yup.string().required("El campo es requerido"),
            [`departureReason_${guid}`]: yup.string().notRequired(),
            [`phone_${guid}`]: yup.string().required("El campo es requerido"),
            [`current_${guid}`]: yup.bool()
        };

        setBasicSchema(() => {
            return newSchema;
        });
        
        setFormContent(() => {
            return {
                ...oldValues,
                [`company_${guid}`]: '',
                [`startDate_${guid}`]: '',
                [`endDate_${guid}`]: '',
                //[`stall_${guid}`]: '',
                [`startyear_${guid}`]: '',
                [`endyear_${guid}`]: '',
                [`supervisor_${guid}`]: '',
                [`functions_${guid}`]: '',
                [`departureReason_${guid}`]: '',
                [`phone_${guid}`]: '',
                [`current_${guid}`]: '',
            }
        });
        
        setExperienceForm(() => {
            return [
                ...experienceForm,
                {
                    id: guid,
                    estado: 1,
                    isNew: true,
                }
            ];
        });
        
        updateFormik(newSchema);
    };

    const onRemoveExperienceForm = (identifier) => {
        let newSchema = basicSchema;
        const oldValues = formRef.current.values;
        const removedForm = experienceForm.find(x => x.id === identifier);

        const schemaKeys = [`company_${identifier}`, 
            `startDate_${identifier}`, 
            `endDate_${identifier}`, 
            //`stall_${identifier}`, 
            `monthlySalary_${identifier}`, 
            `startyear_${identifier}`, 
            `endyear_${identifier}`, 
            `supervisor_${identifier}`, 
            `functions_${identifier}`, 
            `departureReason_${identifier}`, 
            `phone_${identifier}`,
            `current_${identifier}`
        ];

        schemaKeys.forEach(key => {
            delete newSchema[key]
            delete oldValues[key]
        });

        setBasicSchema(() => {
            return newSchema;
        });

        setFormContent(() => {
            return oldValues
        });
        
        updateFormik(newSchema);

        if (removedForm.isNew) {
            setExperienceForm(() => {
                return [
                    ...experienceForm.filter(x => x.id !== identifier)
                ]
            })
        } else {
            const index = experienceForm.indexOf(removedForm);
            let updatedexperienceForm = experienceForm;
            removedForm.estado = 0;
            updatedexperienceForm[index] = removedForm;
            setExperienceForm(() => {
                return [
                    ...updatedexperienceForm
                ]
            })
        }
    };

    const onSaveAndContinue = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(true);
                formRef.current.handleSubmit();
            }
        })
    }

    const onSave = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(false);
                formRef.current.handleSubmit();
            }
        })
    }

    const onExit = () => {
        history.push({
            pathname: "/experience",
            state: {
                updateUserData: true
            }
        });
    }

    const onFormSubmitted = async (form) => {
      try {
        let personaExperiencia = [];
        const symbols = ['(', ')', '-', ' '];
        let onCancelOperation = {
            cancelOperation: false,
            empresas: [],
        };
        let clenaNumber;
        let isInvalidObject = false;
        let empresasConSaluarioCero = [];
        let cancelValidations = [];

        experienceForm.forEach(element => {
            const empresaNombre = (element.estado === 0)
            ? user.persona.personaExperiencia.find(x => x.id === element.id)?.empresaNombre
            : form['company_' + element.id];

            const mesInicioId = (element.estado === 0)
            ? parseInt(user.persona.personaExperiencia.find(x => x.id === element.id)?.mesInicioId)
            : parseInt(form['startDate_' + element.id]);

            const mesFinId = (element.estado === 0)
                ? parseInt(user.persona.personaExperiencia.find(x => x.id === element.id)?.mesFinId)
                : parseInt(form['endDate_' + element.id]);

            const salario = (element.estado === 0)
                ? parseFloat(String(user.persona.personaExperiencia.find(x => x.id === element.id)?.salario).replaceAll(',', ''))
                : parseFloat(String(form['monthlySalary_' + element.id]).replaceAll(',', ''));

            const anioInicio = (element.estado === 0)
            ? parseInt(user.persona.personaExperiencia.find(x => x.id === element.id)?.anioInicio)
            : parseInt(form['startyear_' + element.id]);

            const anioFin = (element.estado === 0)
            ? parseInt(user.persona.personaExperiencia.find(x => x.id === element.id)?.anioFin)
            : parseInt(form['endyear_' + element.id]);

            const supervisor = (element.estado === 0)
            ? user.persona.personaExperiencia.find(x => x.id === element.id)?.supervisor
            : form['supervisor_' + element.id];
            
            const ocupacion = (element.estado === 0)
            ? user.persona.personaExperiencia.find(x => x.id === element.id)?.ocupacion
            : form['functions_' + element.id];

            const motivoSalida = (element.estado === 0)
                ? user.persona.personaExperiencia.find(x => x.id === element.id)?.motivoSalida
                : form['departureReason_' + element.id];

            const empresaTelefono = (element.estado === 0)
                ? user.persona.personaExperiencia.find(x => x.id === element.id)?.empresaTelefono
                : form['phone_' + element.id];
            
            clenaNumber = empresaTelefono;

            symbols.forEach(symbol => {
                clenaNumber = clenaNumber.replace(symbol, '');
            });

            const actual = (element.estado === 0)
            ? parseInt( user.persona.personaExperiencia.find(x => x.id === element.id)?.actual)
            : (form['current_' + element.id] === true)? 1 : 0;

            if (anioInicio && anioFin) {
                if (anioInicio > anioFin) {
                    onCancelOperation.empresas.push(empresaNombre);
                    onCancelOperation.cancelOperation = true;
                }
            }

            if (anioInicio < 0 || anioFin < 0) {
                if (anioInicio < 0) 
                    cancelValidations.push("El año inicio no puede ser negativo en la empresa " + empresaNombre);
                if (anioFin < 0) 
                    cancelValidations.push("El año fin no puede ser negativo en la empresa " + empresaNombre);
                onCancelOperation.cancelOperation = true;
            }

            let dt = new Date();
            let currentYear = Number(dt.getFullYear());

            // if (anioInicio > currentYear || anioFin > currentYear) {
            //     if (anioInicio > currentYear) 
            //         cancelValidations.push("El año inicio no puede ser mayor al actual en la empresa " + empresaNombre);
            //     if (anioFin > currentYear) 
            //         cancelValidations.push("El año fin no puede ser mayor al actual en la empresa " + empresaNombre);
            //     onCancelOperation.cancelOperation = true;
            // }

            if (anioInicio > currentYear || anioFin < anioInicio) {
                if (anioInicio > currentYear) 
                    cancelValidations.push("El año inicio no puede ser mayor al actual en la empresa " + empresaNombre);
                if (anioFin < anioInicio) 
                    cancelValidations.push("El año inicio no puede ser mayor al año fin en la empresa " + empresaNombre);
                onCancelOperation.cancelOperation = true;
            }

            
            const rountededSalary = Math.round(salario)
            
            if (rountededSalary == 0) {
                empresasConSaluarioCero.push(empresaNombre);
                isInvalidObject = true;
            }
            
            const obj = {
                id: element.isNew ? null : element.id,
                personaId: user.persona.id,
                estado: element.estado,
                empresaNombre,
                mesInicioId,
                mesFinId,
                salario: rountededSalary,
                anioInicio,
                anioFin,
                supervisor,
                ocupacion,
                actual,
                motivoSalida,
                empresaTelefono: clenaNumber,
            };

            personaExperiencia.push(obj);
        });

        if (onCancelOperation.cancelOperation) {
            cancelValidations.forEach(validation => {
                notify(validation);
            });
            
            onCancelOperation.empresas.forEach(empresa => {
                notify('El año inicio no puede ser mayor al año fin en la empresa ' + empresa);
            });
            return; 
        }

        if (isInvalidObject) {
            empresasConSaluarioCero.forEach(empresa => {
                notify('No puede guardar el campo último salario mensual devengado con valor 0 en la empresa: '+ empresa);
            });
            return;
        }

        setIsLoading(true);
        const response = await updateMany('PersonaExperiencia', personaExperiencia/* , reCAPTCHA */);

        if (response && response.data && response.data.some(x => x.estado == 1)) {
            SetHasExperience(true);
        } else {
            SetHasExperience(false);
        }

        user.persona = {
            ...user.persona,
            personaExperiencias: [
                ...response.data
            ]
        }
        SetUser(user);
        localStorage.setItem('currentUser-ARS', JSON.stringify(user));
        SetOperationSuccess(opeationSuccess + 1);

        const route = saveAndContinue ? "/reference" : "/experience";
        history.push({
            pathname: route,
            state: {
                updateUserData: true
            }
        });
      } catch (error) {
          console.log(error);
      } finally {
        setIsLoading(false); 
      }
    };

    return (
        <>
            <ToastContainer />
            {
                isLoading &&
                <div className={'display-flex flex-direction-row flex-center'}>
                    <Spinner 
                        animation="grow" 
                        variant="primary" 
                        className={'is-absolute center-spinner-vertically'} 
                        size="lg" />
                </div>
            }
            <Card>
                <Card.Body className={'p-40'}>
                    {
                        loadForm &&
                        <div>
                            <Formik
                                innerRef={formRef}
                                validationSchema={formikSchema}
                                onSubmit={onFormSubmitted}
                                initialValues={formContent}
                                enableReinitialize={true}
                                validateOnChange={false}
                                validateOnBlur={false}
                            >
                                {({
                                    handleSubmit,
                                    handleChange,
                                    handleBlur,
                                    values,
                                    touched,
                                    isValid,
                                    errors,
                                    setFieldValue
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Form.Row>
                                            <Form.Group 
                                                as={Col} 
                                                md="12" 
                                                controlId="campos_obligatorios"
                                                className="mb-0">
                                                    <div style={{fontSize: 18}}>
                                                        <b> Campos obligatorios * </b>
                                                    </div>
                                            </Form.Group>

                                            
                                            <Form.Group as={Col} md="12" className="mb-25">
                                                <span style={{fontSize: 18}}> Por favor coloca sus experiencias laborales, iniciando con la más reciente o actual. </span>
                                            </Form.Group>

                                            {
                                                (experienceForm.length > 0 && experienceForm.filter(x => x.estado === 1).length > 0) ? 
                                                experienceForm.filter(x => x.estado === 1 ).map((element) => {
                                                    return <ExperienceForm 
                                                        key={element.id} 
                                                        handleChange={handleChange} 
                                                        errors={errors} 
                                                        touched={touched} 
                                                        values={values} 
                                                        element={element}
                                                        removeExperienceForm={onRemoveExperienceForm}
                                                        options={exampleOptionsArray} 
                                                        setFieldValue={setFieldValue}/>
                                                })
                                                : 
                                                <Form.Group as={Col} md="12">
                                                    <WarningNotiifcation message='No ha agregado formularios a la sección ' enphasis='Experiencias'/>
                                                </Form.Group>
                                            }
                                            <Form.Group className={'display-flex flex-end'} as={Col} md="12">
                                                <Button onClick={onAddExperienceForm}> Agregar </Button>
                                            </Form.Group>
                                        </Form.Row>

                                        {
                                            experienceForm.length > 0 && 
                                            <Form.Group className={'display-flex space-between padding-right-0'}  as={Col} md="12">
                                                {
                                                    hasExperienceDataReducer 
                                                    ? <Button size="medium" variant="light" onClick={onExit}> <b> Cancelar edición </b> </Button>
                                                    : <div> </div>
                                                }
                                                <div>
                                                    <Button size="medium" type="button" onClick={onSave}> <b> Guardar </b> </Button>
                                                    <Button className={'margin-left-5'} size="medium" type="button" onClick={onSaveAndContinue}> <b> Guardar y continuar </b> </Button>
                                                </div>
                                            </Form.Group>
                                        }

                                    </Form>
                                    )}
                            </Formik>
                        </div>
                    }
                </Card.Body>
            </Card>
        </> 
    );
};
const mapStateToProps = (state) => {
    return {
        user: state.user,
        opeationSuccess: state.opeationSuccess,
        hasExperienceDataReducer: state.hasExperienceDataReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetUser: (user) => dispatch(SetUser(user)),
        SetLoading: (value) => dispatch(SetLoading(value)),
        SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
        SetHasExperience: (value) => dispatch(SetHasExperience(value)),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ExperienceFormWrapper);

